/**
 * @public
 * getValidationCallback: get the validator callback to each fields in Sign Up modal.
 * @param {Object} signUpField with the information of the field 
 * 
 * @returns {Function} that will be execute when form need to be validate.
 */
function getValidationCallback(signUpField) {
    switch(signUpField.name) {
        case 'FirstName':
        case 'LastName': {
            const regex = new RegExp(signUpField.validator.pattern);
            const hint = signUpField.validator.hint;
            return (name) => ({
                valid: regex.test(name) && name.length >= 2,
                hint
            });
        }
        case 'PostalCode': {
            const hint = signUpField.validator.hint;
            return (name) => ({
                valid: name.length === 0 || name.length === 5,
                hint
            });
        }
        default:
            return () => (true);
    }
}

export default getValidationCallback;